import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ModalCloseBtn, useBreakpointHelpers } from '@sweetgreen/garnish';

import { LoadingAnimation } from '@order/components';

import { TransparentModal } from '../../components/TransparentModal';
import { useRateOrderNavigation } from './RateOrder.navigation';
import { useRateOrder } from './RateOrderScreen.data';
import { LandingContent } from './RateOrderScreen.landing';
import { RatingContent } from './RateOrderScreen.rating';

export const RateOrderScreen = () => {
  const {
    loading,
    submitting,
    landingTitle,
    landingSubtitle,
    ratingTitle,
    ratingSubtitle,
    ratingHint,
    ratingCta,
    cards,
    rating,
    handleHoverRating,
    handleRating,
    handleCardSelection,
    handleSubmit,
  } = useRateOrder();
  const { dismissRateOrder } = useRateOrderNavigation();
  const { isMobile } = useBreakpointHelpers();

  return (
    <TransparentModal
      size={isMobile ? 'full' : 'medium'}
      onClose={dismissRateOrder}
    >
      {!isMobile ? <ModalCloseBtn onPress={dismissRateOrder} /> : null}
      {loading ? (
        <View style={styles.loading}>
          <LoadingAnimation />
        </View>
      ) : (
        <>
          {rating === 0 && landingTitle ? (
            <LandingContent
              ratingTitle={ratingTitle}
              landingTitle={landingTitle}
              landingSubtitle={landingSubtitle}
              rating={rating}
              onHoverRating={handleHoverRating}
              onRating={handleRating}
            />
          ) : null}
          {rating > 0 && ratingSubtitle ? (
            <RatingContent
              ratingTitle={ratingTitle}
              ratingSubtitle={ratingSubtitle}
              ratingHint={ratingHint}
              ratingCta={ratingCta}
              cards={cards}
              rating={rating}
              submitting={submitting}
              onHoverRating={handleHoverRating}
              onRating={handleRating}
              onSelectCard={handleCardSelection}
              onSubmit={handleSubmit}
            />
          ) : null}
        </>
      )}
    </TransparentModal>
  );
};

const styles = StyleSheet.create({
  loading: {
    height: 376,
  },
});
